var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A1DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.948 14H10.27a.753.753 0 00-.757.75v10.5c0 .414.339.75.757.75h19.676a.753.753 0 00.757-.75v-10.5a.753.753 0 00-.756-.75z",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.11 23c1.671 0 3.027-1.343 3.027-3s-1.356-3-3.028-3-3.027 1.343-3.027 3 1.355 3 3.027 3zM24.65 14l6.054 5.25M24.65 26l6.054-5.25M15.568 14l-6.054 5.25M15.568 26l-6.054-5.25",
    stroke: "#F2F2F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCash;